import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Holy Crap",
  "description": "",
  "published": "2006-07-31T00:00:00.000Z",
  "redirect_from": ["/blog/holy-crap/swizec/394"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/3_1.jpg",
        "alt": null
      }}></img></p>
    <p>{`The end of the month is apparently here, this means that the month is over and the same oges for the time left to create this month's comic. Sadly there is also the fact hat the comic hasn't been finished yet, mostly because the idea is to produce quality work and there simply hasn't been much time to devote to it so it didn't get finished. I will do my best to get the issue finished by hte end of the week and then it shall be called the August update.`}<br parentName="p"></br>{`
`}{`This might seem as a dirty trick I know, but it will enable me to work on the comics for next month rather than rushing to complete comics for this month. That means, I labour all month just as now, but then the update happens in the beginning of the month, pretty good huh.`}</p>
    <p>{`Also you mahe have noticed that the webcam on the left hasn't been performing it's duties, this is because the uploader keeps complaining about some socket error, I have no idea what it's nagging on about but it just cannot upload the camera image. Will have to look into fixing that in the immediate future.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      